module.exports = __webpack_public_path__ + "img/evaluationrp.fe409833.svg";